/**
 * Created by razial on 21.08.2025.
 */

const TravelMap = function (options) {
    cleverapps.EventEmitter.call(this);

    options = options || {};

    this.animateNext = options.animateNext;
    this.levelsCountInPage = options.levelsCountInPage;

    this.location = cleverapps.meta.getSelectedLocation();
    this.roomsMode = typeof RepairLocation !== "undefined" && (this.location instanceof RepairLocation);

    if (this.roomsMode) {
        this.selectedBuilding = this.location.getCurrentRoom();
    } else {
        this.selectedBuilding = cleverapps.meta.selectedLocationId();
    }
};

TravelMap.prototype = Object.create(cleverapps.EventEmitter.prototype);
TravelMap.prototype.constructor = TravelMap;

TravelMap.prototype.listPages = function () {
    const pages = [];

    const buildings = this.listBuildings();

    for (let i = 0; i < buildings.length; i += this.levelsCountInPage) {
        pages.push({
            pageNo: Math.floor(i / this.levelsCountInPage),
            buildings: buildings.slice(i, i + this.levelsCountInPage)
        });
    }

    return pages;
};

TravelMap.prototype.listBuildings = function () {
    const buildings = [];

    if (this.roomsMode) {
        for (let buildingId = 0; buildingId < this.location.getTotalRooms(); ++buildingId) {
            buildings.push(buildingId);
        }
    } else {
        for (let buildingId = 0; cleverapps.meta.isLocationAvailable(buildingId); ++buildingId) {
            buildings.push(buildingId);
        }
    }

    do {
        buildings.push(buildings.length);
    } while (buildings.length % this.levelsCountInPage !== 0);

    return buildings;
};

TravelMap.prototype.getSelectedBuilding = function () {
    return this.selectedBuilding;
};

TravelMap.prototype.getBuildingState = function (buildingId) {
    if (this.roomsMode) {
        let state = TravelMap.BUILDING_STATE.NEXT;

        if (buildingId === this.selectedBuilding) {
            state = TravelMap.BUILDING_STATE.CURRENT;
        } else if (buildingId < this.selectedBuilding) {
            state = TravelMap.BUILDING_STATE.PASSED;
        }

        return state;
    }

    let activeLocations = [cleverapps.meta.getSelectedLocation().locationId];

    if (this.animateNext) {
        const nextLocationId = this.selectedBuilding + 1;

        activeLocations = activeLocations.filter((locationId) => locationId !== nextLocationId);
    }

    let state = TravelMap.BUILDING_STATE.NEXT;

    if (activeLocations.includes(buildingId)) {
        state = TravelMap.BUILDING_STATE.CURRENT;
    } else if (buildingId < this.selectedBuilding) {
        state = TravelMap.BUILDING_STATE.PASSED;
    }

    return state;
};

TravelMap.prototype.getBuildingProgress = function () {
    if (this.animateNext) {
        return 80;
    }

    if (this.roomsMode) {
        return this.location.getProgress();
    }

    return cleverapps.meta.getSelectedLocation().getProgress();
};

TravelMap.prototype.getBuildingReward = function () {
    if (this.roomsMode) {
        return;
    }

    const location = cleverapps.meta.getSelectedLocation();
    return location.getLocationCompleteReward && location.getLocationCompleteReward();
};

TravelMap.prototype.isBuildingUnknown = function (buildingId) {
    if (this.roomsMode) {
        return !(buildingId < this.location.getTotalRooms());
    }

    return !cleverapps.meta.isLocationAvailable(buildingId);
};

TravelMap.prototype.getUnknownIndex = function (buildingId) {
    return this.listBuildings().filter((id) => id < buildingId && this.isBuildingUnknown(id)).length;
};

TravelMap.prototype.isBuildingOpening = function (buildingId) {
    return Boolean(this.animateNext) && buildingId === this.getSelectedBuilding() + 1;
};

TravelMap.prototype.isBuildingSelected = function (buildingId) {
    return this.getSelectedBuilding() === buildingId;
};

TravelMap.prototype.isBuildingClickable = function (buildingId) {
    if (this.getBuildingState(buildingId) === TravelMap.BUILDING_STATE.NEXT) {
        return false;
    }

    if (this.roomsMode) {
        return false;
    }

    return cleverapps.meta.isLocationActive(buildingId);
};

TravelMap.prototype.onShow = function () {
    if (!this.animateNext) {
        return;
    }

    cleverapps.focusManager.display({
        focus: "TravelMapNextAnimation",
        stack: true,
        actions: [
            (f) => {
                cleverapps.timeouts.setTimeout(f, 500);
            },

            (f) => {
                this.animatingBuilding = this.getSelectedBuilding();

                this.trigger("runPassedAnimation", this.animatingBuilding);
                this.trigger("runOpenAnimation", this.animatingBuilding + 1);
                f();
            },

            (f) => {
                this.finishAnimation = f;
                this.animationTimeout = cleverapps.timeouts.setTimeout(f, 7000);
            },

            (f) => {
                this.animatingBuilding = undefined;
                this.finishAnimation = undefined;
                this.animationTimeout = undefined;

                this.trigger("closeWindow");
                f();
            }
        ]
    });
};

TravelMap.prototype.stopAnimation = function () {
    if (this.animatingBuilding === undefined) {
        return;
    }

    cleverapps.timeouts.clearTimeout(this.animationTimeout);
    this.animationTimeout = undefined;

    const finish = this.finishAnimation;
    this.finishAnimation = undefined;

    if (finish) {
        finish();
    }
};

TravelMap.prototype.onClick = function (buildingId) {
    cleverapps.focusManager.distract({
        focus: "TravelMap.gotoLocation",
        action: (f) => {
            if (this.roomsMode) {
                return;
            }

            cleverapps.meta.switchLocation(buildingId);
            cleverapps.meta.gotoLocationScene(f);
        }
    });
};

TravelMap.prototype.onDebugClick = function (buildingId) {
    if (this.roomsMode) {
        if (!this.isBuildingUnknown(buildingId)) {
            cleverapps.focusManager.distract({
                focus: "TravelMap.gotoRoom",
                action: (f) => {
                    cleverapps.meta.getSelectedLocation().changeRoom(buildingId);
                    Merge2.current.recalcLevelProgress();
                    cleverapps.meta.getSelectedLocation().updateRoom(f);
                }
            });
        }
        return;
    }

    if (!cleverapps.meta.isLocationAvailable(buildingId)) {
        return;
    }

    cleverapps.meta.listActiveLocations().forEach((locationId) => {
        const locationMeta = cleverapps.meta.getLocationMeta(locationId);
        locationMeta.locationConfig.slot.reset();
    });

    cleverapps.meta.mainLocationId = buildingId;
    Object.values(cleverapps.meta.locations).forEach((locationMeta) => {
        locationMeta.reset();
    });

    cleverapps.meta.listActiveLocations().forEach((locationId) => {
        cleverapps.meta.startLocation(locationId);
    });

    this.onClick(buildingId);
};

TravelMap.BUILDING_STATE = {
    PASSED: "passed",
    CURRENT: "current",
    NEXT: "next"
};